import Swal from 'sweetalert2';

// ── Estilos padrão (Tailwind) aplicados via customClass ─────────────────────
// Como usamos buttonsStyling: false, os botões herdam apenas as classes abaixo.
const baseCustomClass = {
  popup: 'rounded-xl',
  confirmButton:
    'bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-lg',
  cancelButton:
    'bg-red-600 hover:bg-red-700 text-white text-sm font-medium px-4 py-2 rounded-lg ml-2',
};

const baseOptions = {
  buttonsStyling: false,
  showCloseButton: false,
};

// ── Alertas simples ─────────────────────────────────────────────────────────

/** Alerta de sucesso. */
export const successAlert = (title, text) =>
  Swal.fire({
    ...baseOptions,
    icon: 'success',
    title,
    text,
    customClass: { ...baseCustomClass },
  });

/** Alerta de erro. */
export const errorAlert = (title, text) =>
  Swal.fire({
    ...baseOptions,
    icon: 'error',
    title,
    text,
    customClass: { ...baseCustomClass },
  });

/** Alerta de aviso. */
export const warningAlert = (title, text) =>
  Swal.fire({
    ...baseOptions,
    icon: 'warning',
    title,
    text,
    customClass: { ...baseCustomClass },
  });

/** Alerta informativo. */
export const infoAlert = (title, text) =>
  Swal.fire({
    ...baseOptions,
    icon: 'info',
    title,
    text,
    customClass: { ...baseCustomClass },
  });

// ── Diálogos interativos ────────────────────────────────────────────────────

/**
 * Diálogo de confirmação.
 * Retorna Promise<boolean>: true se o usuário confirmou, false caso contrário.
 */
export const confirmDialog = async ({
  title,
  text,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  icon = 'warning',
}) => {
  const result = await Swal.fire({
    ...baseOptions,
    icon,
    title,
    text,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    customClass: { ...baseCustomClass },
  });
  return result.isConfirmed;
};

/**
 * Diálogo com campo de texto (textarea).
 * Retorna Promise<string|null>: o texto digitado, ou null se cancelou/vazio.
 */
export const promptDialog = async ({
  title,
  text,
  placeholder,
  inputValue = '',
  confirmText = 'Salvar',
  cancelText = 'Cancelar',
}) => {
  const result = await Swal.fire({
    ...baseOptions,
    title,
    text,
    input: 'textarea',
    inputValue,
    inputPlaceholder: placeholder,
    inputAttributes: {
      'aria-label': title || 'Texto',
    },
    inputValidator: (value) => {
      // Impede salvar com campo vazio — retorna mensagem de validação
      if (!value || !value.trim()) {
        return 'Informe um texto para continuar.';
      }
      return undefined;
    },
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    customClass: {
      ...baseCustomClass,
      input: 'border border-gray-300 rounded-lg px-3 py-2 text-sm w-full',
    },
  });

  // Cancelado (ou fechado) => null; confirmado => texto digitado
  if (!result.isConfirmed) return null;
  const value = (result.value || '').trim();
  return value === '' ? null : value;
};
